// The connectors page BI identity, in its own tiny module so both the connectors controllers
// (lib/use-connectors.ts) and the reusable connect action (lib/use-connect-connector.ts) can read it
// without a circular import between them. Re-exported from lib/use-connectors.ts, which is where every
// component still imports it from.
export const CONNECTORS_PAGE = { page_name: 'connectors' as const, page_version: 'v1_connectors' as const };
